module.exports = __webpack_public_path__ + "resources/54f3e72991655c6b0342f33464d40449.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/oversizedlocationv.png
// module id = 220
// module chunks = 0